module.exports = __webpack_public_path__ + "static/media/Omkar_Oak.4bce2873.jpg";